let clientTMLStorefront, byText, recipeText, difficultyText, personsText, minutesText;

if(document.body.classList.contains('DE')) {
  clientTMLStorefront = ShopifyStorefrontAPIClient.createStorefrontApiClient({
    storeDomain: 'https://the-meat-lovers-de.myshopify.com',
    apiVersion: '2024-04',
    publicAccessToken: '3cddbc37d5010140324ecf3f5a01f896',
  });
  byText = 'Von:';
  recipeText = 'rezepte';
  difficultyText = 'Schwierigkeit';
  personsText = 'Personen';
  minutesText = 'Minuten';
} else {
  clientTMLStorefront = ShopifyStorefrontAPIClient.createStorefrontApiClient({
    storeDomain: 'https://tml-dev.myshopify.com',
    apiVersion: '2024-04',
    publicAccessToken: '695a8edfc38af7db88541552c17696ff',
  });
  byText = 'Door:';
  recipeText = 'recepten';
  difficultyText = 'Moeilijkheid';
  personsText = 'personen';
  minutesText = 'minuten';
}

window.filteredRecipes = [];

window.fetchRecipes = async (author = '', meat = '', keyword = '', sort = 'desc', limit = 12, offset = 0) => {
  document.querySelector('.recipe-cards__cards').classList.add('is-loading');

  // Exit if filters are empty
  if (!author && !meat && !keyword && !sort) {
    window.location.reload();
    return;
  }

  const query = `
    query getMetaObjects($type: String!, $sortKey: String, $first: Int, $reverse: Boolean) {
      metaobjects(
        type: $type,
        sortKey: $sortKey,
        first: $first,
        reverse: $reverse
      ) {
        edges {
          node {
            id
            fields {
              reference {
                ... on MediaImage {
                  image {
                    url
                  }
                }
                ... on Metaobject {
                  fields {
                    key
                    value
                  }
                }
              }
              key
              value
            }
            handle
            updatedAt
            type
          }
        }
      }
    }
  `;

  try {
    const { data, errors } = await clientTMLStorefront.request(query, {
      variables: {
        type: 'recipe',
        sortKey: 'updatedAt',
        first: 250,
        reverse: sort === 'desc'
      }
    });

    if (errors) {
      console.error(errors);
      return;
    }

    // Filter the results
    const recipes = data.metaobjects.edges;
    window.filteredRecipes = recipes.filter(recipe => {
      const fields = recipe.node.fields;
      const authorFilter = author ? fields.find(field => field.key === 'expert' && field.value === 'gid://shopify/Metaobject/' + author) : true;
      const meatFilter = meat ? fields.find(field => field.value.toLowerCase().includes(meat.toLowerCase())) : true;
      const keywordFilter = keyword ? fields.find(field => field.value.toLowerCase().includes(keyword.toLowerCase())) : true;
      return authorFilter && meatFilter && keywordFilter;
    });

    window.filteredRecipes.sort((a, b) => {
      const dateA = new Date(a.node.updatedAt);
      const dateB = new Date(b.node.updatedAt);
      
      if (sort === 'asc') {
        return dateA - dateB;
      } else if (sort === 'desc') {
        return dateB - dateA;
      } else {
        throw new Error("Invalid sort order. Use 'asc' or 'desc'.");
      }
    });

    // Render the filtered recipes
    renderFilteredRecipes(limit, offset);
  } catch (error) {
    console.error('Error fetching recipes:', error);
  }
};

window.renderFilteredRecipes = (limit, offset) => {
  const recipes = window.filteredRecipes;
  const grid = document.querySelector('.recipe-cards__cards');
  const recipesToRender = recipes.slice(offset, offset + limit);
  const noResults = document.querySelector('.recipes-index .no-results');
  grid.innerHTML = '';
  noResults.classList.remove('is-visible');

  if (recipesToRender.length === 0) {
    noResults.classList.add('is-visible');
    grid.classList.remove('is-loading');
    renderPagination(recipes.length, limit, offset);
    return;
  }

  recipesToRender.forEach(recipeNode => {
    const url = `/pages/${ recipeText }/` + recipeNode.node.handle;
    const recipe = recipeNode.node.fields.reduce((acc, field) => {
      acc[field.key] = { 
        'value': field.value,
        'reference': field.reference
      };
      return acc;
    }, {});

    const expert = recipe.expert.reference.fields.reduce((acc, field) => {
      acc[field.key] = { 
        'value': field.value
      };
      return acc;
    }, {});

    let difficulty = recipe.difficulty_level.value;
    let diffHats = '';

    for (let i = 0; i < difficulty; i++) {
      diffHats += '<span class="difficulty fa fa-hat-chef fa-regular" aria-hidden="true"></span> ';
    }

    const banner = recipe.banner ? recipe.banner.reference.image.url : 'https://cdn.shopify.com/s/files/1/0610/9436/3286/files/TML_logo.webp?v=1659087675';
    const card = `
      <a class="recipe-cards__card" href="${url}">
        <img src="${banner}" alt="${recipe.title.value}">
        <div class="recipe-cards__card-content">
          <h5>${ byText } ${expert.name.value}</h5>
          <h4>${recipe.title.value}</h4>
          <span class="fa fa-clock fa-regular" aria-hidden="true"></span> ${recipe.cooking_time_minutes.value} ${ minutesText }<br>
          <span class="fa fa-users fa-regular" aria-hidden="true"></span> ${recipe.number_of_persons.value} ${ personsText }<br>
          <span class="fa fa-knife-kitchen fa-regular" aria-hidden="true"></span> ${ difficultyText }: ${diffHats}
        </div>
      </a>
    `;
    grid.innerHTML += card;
  });

  // Render the pagination
  renderPagination(recipes.length, limit, offset);

  grid.classList.remove('is-loading');
};

const renderPagination = (total, limit, offset) => {
  const pagination = document.querySelector('.recipes-index__pagination ul');
  const pages = Math.ceil(total / limit);
  const currentPage = Math.floor(offset / limit) + 1;

  if (pages <= 1) {
    pagination.innerHTML = '';
    return;
  }

  let buttons = '';

  // Function to create the URL with the updated offset
  const getPageUrl = (newOffset) => {
    const url = new URL(window.location.href);
    url.searchParams.set('offset', newOffset);
    return url.toString();
  };

  // Add "Previous" page button if not on the first page
  if (currentPage > 1) {
    buttons += `<li><a href="${getPageUrl((currentPage - 2) * limit)}"><span class="fa fa-arrow-left"></span></a></li>`;
  }

  // Add "First" page button
  if (currentPage !== 1) {
    buttons += `<li><a href="${getPageUrl(0)}">1</a></li>`;
  } else {
    buttons += `<li><span class="is-active">1</span></li>`;
  }

  // Add ellipsis if there's a gap between the first page and the startPage
  const startPage = Math.max(2, currentPage - 2);
  const endPage = Math.min(pages - 1, currentPage + 2);

  if (startPage > 2) {
    buttons += `<li><span>...</span></li>`;
  }

  // Add page buttons within the visible range
  for (let i = startPage; i <= endPage; i++) {
    if (i === currentPage) {
      buttons += `<li><span class="is-active">${i}</span></li>`;
    } else {
      buttons += `<li><a href="${getPageUrl((i - 1) * limit)}">${i}</a></li>`;
    }
  }

  // Add ellipsis if there's a gap between the endPage and the last page
  if (endPage < pages - 1) {
    buttons += `<li><span>...</span></li>`;
  }

  // Add "Last" page button
  if (currentPage !== pages) {
    buttons += `<li><a href="${getPageUrl((pages - 1) * limit)}">${pages}</a></li>`;
  } else {
    buttons += `<li><span class="is-active">${pages}</span></li>`;
  }

  // Add "Next" page button if not on the last page
  if (currentPage < pages) {
    buttons += `<li><a href="${getPageUrl(currentPage * limit)}"><span class="fa fa-arrow-right"></span></a></li>`;
  }

  pagination.innerHTML = buttons;
};

// Call fetchRecipes on page load
document.addEventListener("DOMContentLoaded", () => {
  const urlParams = new URLSearchParams(window.location.search);
  const offset = parseInt(urlParams.get('offset'), 10) || 0;
  fetchRecipes('', '', '', 'desc', 12, offset);
});

